var map = {
	"./cancel.png": "17aa",
	"./checked.png": "1442",
	"./cloud-green.png": "4613",
	"./cloud-purple.png": "5e43",
	"./cloud.png": "845b",
	"./map.png": "48dd",
	"./mother.png": "7899",
	"./phone1.png": "6598",
	"./phone2.png": "158a",
	"./phone3.png": "96be",
	"./place.png": "3ac5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";